module.exports = __webpack_public_path__ + "static/kylegrinstead2021-500.325cd67e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/kylegrinstead2021-500.jpg
// module id = 107
// module chunks = 35783957827783 95715928098905 107818501498521